import axios from 'axios';

export function getRequest(getUrl, params) {
  return new Promise((resolve, reject) => {
    axios.get(getUrl, { params: params})
      .then((res) => {
        resolve(res);
      })
      .catch((err)=> reject(err));
  });
}

export function postRequest(postUrl, params, headers={"Content-Type":"application/json; charset=utf-8"}) {
  return new Promise((resolve, reject) => {
    axios.post(postUrl, params, headers)
      .then((res) => {
        resolve(res);
      })
      .catch((err)=> reject(err));
  });
}

export function putRequest(putUrl, params) {
  return new Promise((resolve, reject) => {
    axios.put(putUrl, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err)=> reject(err));
  });
}


// WEBPACK FOOTER //
// ./src/config/fetch.js